import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';

import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'auto-handover',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			isLoadingSearch: false,
			areaBarcode:"",
		    entityName:"",
			autoHandoverBatchData :{},
			BatchDetails:{},
			hubDetailsData :{},
			bagNo:"",
			batchid:"",
			handOverAreaErrorMSG:"",
			ConfirmationModal : false,
			bagNoErrorMSG:"",
			batchLoading  : '',
			showConfirm: false,
			isBarcodeScan: false,
			showMultipartBagPendingModal :false,
			multipartBagDetails : [],
			showBag:false
		}
	},
	created: function() {},
	computed: {},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
	},
	methods: {
			getBarcodeScan() {
				this.entityName = '';
				this.autoHandoverBatchData = [];
				this.batchid ='';
				this.bagNo="";
				if (this.areaBarcode == '' || this.areaBarcode== undefined) {
					this.handOverAreaErrorMSG = 'Enter HandOver Area Barcode';
					return false;
				}
				this.handOverAreaErrorMSG = '';
				axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops  + 'showHandoverEntityDetails?Barcodedata=' + this.areaBarcode,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}	
				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData) {
							this.hubDetailsData = response.ResponseData;
							this.entityName = this.hubDetailsData[0].tohubname;
						}
					} else {
						this.hubDetailsData  = {};
						this.entityName= "";
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error)
				})
			}
			,

			startScan() {
				if (this.areaBarcode == '' || this.areaBarcode== undefined) {
					this.handOverAreaErrorMSG = 'Enter HandOver Area Barcode';
					return false;
				}
				this.handOverAreaErrorMSG = '';
				this.isLoadingSearch = false;
				this.autoHandoverBatchData = [];
				this.isBarcodeScan = false;
				this.batchid ='';
				this.input = ({
					FromHubId: this.hubDetailsData[0].fromhubid,
					ToHubId: this.hubDetailsData[0].tohubid,
					Barcodedata: this.areaBarcode,
					createdBy: this.useremail,
				})
				this.isLoadingSearch =true;
				axios({
					method: "POST",
					'url': apiUrl.api_url_hubops + 'CreateAutoHandoverBatch',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				}).then(result => {
					this.isLoadingSearch =false;
					let response = result.data;
					if (response.ResultCode == 100 && response.ResponseData) {
						this.isBarcodeScan = true;
						let BatchDetails = response.ResponseData;
						this.batchid = BatchDetails.batchid;
						if(BatchDetails.noofbags != 0 || BatchDetails.noofmps != 0){
                           let handoverEntity = this.hubDetailsData[0].tohubname;
						   let Bags = BatchDetails.BagData;
						   for(let i= 0 ; i < Bags.length; i++){
							this.autoHandoverBatchData.push({
								bagNo: Bags[i].bagno,
								handoverEntity: handoverEntity,
								timestamp:Bags[i].createddate ,
								batchId : BatchDetails.batchid,
								currenthubid:BatchDetails.currenthubid,
							})
						   }

						}
					
					}else{
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error);
					this.autoHandoverBatchData =[];
					this.isLoadingSearch =false;
				})
			}
				,

			bagInscan(){
				this.multipartBagDetails = [];
				if (this.bagNo == '' || this.bagNo == undefined) {
					this.bagNoErrorMSG = 'Bag/Mps no is required';
					return false;
				}
				this.bagNoErrorMSG = '';
				this.input = ({
					Batchid: this.batchid,
					HubId: this.hubDetailsData[0].fromhubid,
					HubName:this.hubDetailsData[0].fromhubname,
                    BagNo: this.bagNo,
					createdBy: this.useremail,
				})
				this.batchLoading = 'Loading Batch...'
				axios({
					method: "POST",
					'url': apiUrl.api_url_hubops + 'HandoverAddtoBatch',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				}).then(result => {
					this.batchLoading  = ''
					let response = result.data;
					if (response.ResultCode == 100 ) {
					    this.$alertify.success(result.data.ReturnMessage)
						this.startScan();
					}
					else if(response.ResultCode == 110){
						this.showBag = false;
					    this.multipartBagDetails = result.data.ResponseData;
						this.showMultipartBagPendingModal = true;
						this.$alertify.error(result.data.ReturnMessage);
					}else{
						this.$alertify.error(result.data.ReturnMessage);
					}
				}, error => {
					console.error(error);
					this.batchLoading  = ''
				})


			}
            ,
			removeBag(data){
				this.input = ({
					BagNo: data.bagNo,
					Batchid: data.batchId,
					HubId: this.hubDetailsData[0].fromhubid,
					HubName: this.hubDetailsData[0].fromhubname,
					ModifiedBy: this.useremail
				  })
				 
				  axios({
					  method: 'PUT',
					  'url': apiUrl.api_url_hubops + 'RemoveBag',
					  'data': this.input,
					  headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					  }
					})
					.then(result => {
					  if (result.data.ResultCode == 100) {
						this.$alertify.success('Remove Successfully', "", "success")
						this.startScan(); 
					  }else{
						this.$alertify.error(result.data.ReturnMessage);
					  }
					}, error => {
					  console.error(error)
					})

			}
			,
			removeAllBag(){
				this.isLoadingSearch = false;
				this.input = ({
					Batchid: this.batchid,
					HubId:  this.hubDetailsData[0].fromhubid,
					HubName:  this.hubDetailsData[0].fromhubname,
					ModifiedBy: this.useremail
				  })
				  this.isLoadingSearch = true;
				  axios({
					  method: 'PUT',
					  'url': apiUrl.api_url_hubops + 'RemoveAllBags',
					  'data': this.input,
					  headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					  }
					})
					.then(result => {
					  this.isLoadingSearch = false;
					  if (result.data.ResultCode == 100) {
						this.$alertify.success('Removed All Bags Successfully', "", "success")
						this.startScan(); 
					  }else{
						this.$alertify.error(result.data.ReturnMessage);
					  }
					  this.ConfirmationModal = false;
					}, error => {
					  console.error(error)
					  this.isLoadingSearch = false;
					})

			}
         ,

		    confirmBagHandover(){
                this.multipartBagDetails = [];
				this.isLoadingSearch = false;
				this.input = ({
					batchId: this.batchid,
					currentHubId:  this.hubDetailsData[0].fromhubid,
					currentHubName:  this.hubDetailsData[0].fromhubname,
					destinationHubId:this.hubDetailsData[0].tohubid,
					destinationHubName:this.hubDetailsData[0].tohubname,
					createdBy: this.useremail
				})
				this.isLoadingSearch =true;
			  	axios({
				  method: "POST",
				  'url': apiUrl.api_url_hubops + 'BagHandover',
				  'data': this.input,
				  headers: {
					  'authorization': 'authkey xB84JJ89Hd25',
				  }
			  	}).then(result => {
				  this.isLoadingSearch =false;
				  let response = result.data;
				  if (response.ResultCode == 100) {
					  this.$alert(result.data.ReturnMessage, "", "success");
					  this.resetForm();
				  }else if(response.ResultCode == 110){
					    this.showBag = true;
					    this.multipartBagDetails = result.data.ResponseData;
						this.showMultipartBagPendingModal = true;
						this.$alertify.error(result.data.ReturnMessage);
				  }
				  else{
					  this.$alertify.error(result.data.ReturnMessage);
				  }
				  this.ConfirmationModal = false;
			  }, error => {
				  console.error(error);
				  this.isLoadingSearch =false;
				  
			  	})
			  

		    },

		    openConfirmationModal(data) {
				this.showConfirm = data;
			    this.ConfirmationModal = true;
			},
		    closeConfirmationModal() {
			    this.ConfirmationModal= false;
				this.showConfirm = false;
		    },

			resetForm() {
			    this.entityName = "";
				this.areaBarcode = "";
				this.autoHandoverBatchData = [];
				this.batchid ='';
				this.bagNo="";
				this.handOverAreaErrorMSG ="";
				this.bagNoErrorMSG = "";
				this.batchLoading  = '';
				this.isBarcodeScan = false;
				this.$validator.reset();
				this.errors.clear();
				this.multipartBagDetails = [];
		    }
            ,
			reset(){
				this.bagNo="";
				this.bagNoErrorMSG = "";
				this.batchLoading  = '';
			}
			,

			closeMutlipartPendingModal(){
				this.showMultipartBagPendingModal  =false;
		        this.multipartBagDetails = [];
			}


	}

}




// WEBPACK FOOTER //
// ./src/views/components/AutoHandover/Handover/Handover.js